import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LogItem  from './LogItem';
import { IActivityLogSearchResult } from '../domain/ActivityLog';
import { IonList } from '@ionic/react';

interface LogItemListProps extends RouteComponentProps{
    resultList: IActivityLogSearchResult[]
    refresh: any
};

const LogItemList: React.FC<LogItemListProps> = ({resultList, history, location, match, refresh}) => {
    return (
        <IonList className="my-ionlist">
            {  resultList.map((x:IActivityLogSearchResult) => 
                {
                    return <LogItem key= {x.ActivityLogID} item={x} history={history} location={location} match={match} refresh= {refresh}></LogItem>
                })
            }
        </IonList>
    );  
};

export default LogItemList;